export function log(experimentKey: string, variantName: string, payload: any) {
  const prefix = '\ud83d\udd35 $experiment_started:';
  console.info(
    `${prefix} experiment "${experimentKey}" and variant "${variantName}"`,
  );
  console.info(`${prefix} payload`, payload);
}
